import { render, staticRenderFns } from "./orderBill.vue?vue&type=template&id=dc39e398&scoped=true"
import script from "./orderBill.vue?vue&type=script&lang=js"
export * from "./orderBill.vue?vue&type=script&lang=js"
import style0 from "./orderBill.vue?vue&type=style&index=0&id=dc39e398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc39e398",
  null
  
)

export default component.exports